import moment from 'moment';
import React, { useEffect, useRef, useState } from 'react';
import { FlatList, ScrollView, SectionList, View, VirtualizedList } from "react-native"
import { Icon } from 'react-native-elements';
import { useSelector } from "react-redux"
import Colors from '../../constants/Colorsv2';
import { Text, TouchableOpacity } from '../../globalComponents/NativeOverrides';
import { social_getRelatedGroupId } from '../../store/actionsv1/social';
import { LeagueProps } from '../../store/types/sr_svc';
import GroupChatModal from '../Social/components/GroupChatModal';
import LeagueSchedule from './components/LeagueSchedule';
import { Helmet } from 'react-helmet-async';

const default_tourney_leagues = ['UFC','PGA','BOXING','HORSE']

const LeagueScreen = ({ route, navigation }:any) => {
    const [ group_id, setGroupId ] = useState<string|undefined>(undefined)
    const [ chat_expanded, setChatExpanded ] = useState(false);
    const league_scroll_ref = useRef();
    const app_size:{ width:number } = useSelector((state:any) => state.util.app_size, (left, right) => left?.width == right?.width)
    const league:LeagueProps | undefined = useSelector((state:any) => state.event.leagues.find((l:LeagueProps) => l.league_id == route.params.league_id), (left, right) => left?.league_id == right?.league_id)    
    

    useEffect(() => {
        getGroupIdFromServer()
    },[route.params.league_id])

    const getGroupIdFromServer = async() => {
        let group_id = await social_getRelatedGroupId(route.params.league_id, 'league')
        if(!group_id){ return }
        setGroupId(group_id)
    }

    const renderComponents = (data: { item:string, index:number }) => {
        if(data.item == 'header'){
            return (
                <View style={{ backgroundColor:Colors.shades.shade100, paddingTop:8, paddingBottom:8, flexDirection:'row', alignItems:'center' }}>
                    <TouchableOpacity style={{ margin:5, marginLeft:15 }} onPress={() => navigation.navigate('Events')}>
                        <Icon size={16} name='home' type='feather' color={Colors.brand.midnight}/>
                    </TouchableOpacity>
                    <View style={{ margin:5 }}>
                        <Icon size={16} name='chevron-right' type='feather' color={Colors.brand.midnight}/>
                    </View>
                    <View style={{ margin:5 }}>
                        <Text size={16} color={Colors.brand.midnight} weight='light'>{league?.sport}</Text>
                    </View>
                    <View style={{ margin:5 }}>
                        <Icon size={16} name='chevron-right' type='feather' color={Colors.brand.midnight}/>
                    </View>
                    <View style={{ flexDirection:'row', alignItems:'center', margin:5 }}>
                        <Text size={16} color={Colors.brand.midnight} weight='semibold' style={{marginRight:5}}>{league?.league_name}</Text>
                    </View>
                </View>
            )
        }
        if(data.item == 'schedule'){
            if(!league){ return <></> }
            return (
                <View nativeID='league_schedule'>
                    <LeagueSchedule 
                        navigation={navigation} 
                        onScrollTo={(offset) => {
                            if(league_scroll_ref){
                                league_scroll_ref.current.scrollToOffset({ offset })
                            }
                        }}
                        default_tournaments={league?.default_tournaments}
                        league_id={league.league_id}
                        default_date={moment().format('YYYY-MM-DD')}
                        source='market'
                        />
                </View>
            )
        }
        return <></>
    }

    const components = ['header','schedule']
    
    if(!league){
        return (<></>)
    }
    return (
        <View style={{ flex:1, backgroundColor:Colors.shades.white }}>
            <Helmet>
                <title>{league.league_name} Betting Markets</title>
                <meta name='description' content={`BettorEdge betting markets for the ${league.league_name}`} />
                <meta name='og:image' content={league.league_image} />
            </Helmet>
            <FlatList 
                ref={league_scroll_ref}
                style={{ paddingBottom:75 }}
                data={components}
                windowSize={10}
                maxToRenderPerBatch={10}
                renderItem={renderComponents}
                keyExtractor={(item) => item}
            />
            <View style={{ position:'absolute', bottom:20, left:20, alignItems:'flex-start' }}>
                <TouchableOpacity 
                style={{ justifyContent:'center', alignContent:'center', borderRadius:100, height:50, width:50, backgroundColor:Colors.brand.electric,  shadowColor: "rgba(0, 0, 0, 0.12)", shadowOffset: { width: 0, height: 10 }, shadowRadius: 10, shadowOpacity: 1 }} 
                onPress={() => setChatExpanded(true)} >
                    <Icon name='message-circle' type='feather' size={20} color={Colors.shades.white} />
                </TouchableOpacity>
            </View>
            <GroupChatModal 
                expanded={chat_expanded}
                onCloseExpand={() => setChatExpanded(false)}
                show_last_message
                group_id={group_id}
                bottom={20}
                left={20}
                expanded_width={app_size.width}
                onLastMessageUpdate={() => 'hey'}
            />
        </View>
    )
}

export default LeagueScreen